<div class="relative w-full max-w-md border-b border-gray-600">
  <input
    type="text"
    class="search-bar"
    [placeholder]="placeholder()"
    name="search"
    [formControl]="searchControl" />
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    class="absolute top-1 left-0 h-5 w-5 cursor-pointer text-gray-400 transition hover:text-white">
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1111 3a7.5 7.5 0 015.65 12.65z" />
  </svg>

  @if (searchControl.value?.trim() !== '') {
    <svg
      (click)="searchControl.setValue('')"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="2"
      stroke="currentColor"
      class="absolute top-1 right-0 h-5 w-5 cursor-pointer text-red-400 transition hover:text-white">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12" />
    </svg>
  }
</div>
